import React from 'react';
import { Card, Badge, Row, Col } from 'react-bootstrap';
//import './DietCompatibilityStyles.css';

const DietCompatibility = ({ compatibility }) => {
    const entries = Object.entries(compatibility || {});

    if (!entries.length) return null;

    return (
        <Card className="clean-card shadow-sm mb-4">
            <div className="card-header">
                <h4 className="mb-0">
                    <span className="diet-icon">🥗</span> Diet Compatibility
                </h4>
            </div>
            <Card.Body>
                <Row>
                    {entries.map(([diet, allowed], idx) => (
                        <Col key={idx} xs={12} sm={6} md={4} className="mb-3">
                            <div className="diet-item">
                                <Badge className={`badge ${allowed ? 'success' : 'danger'} diet-badge`}>
                                    {allowed ? '✓ Allowed' : '✗ Not Allowed'}
                                </Badge>
                                <span className="diet-name ms-2">{diet}</span>
                            </div>
                        </Col>
                    ))}
                </Row>
            </Card.Body>
        </Card>
    );
};

export default DietCompatibility;
